import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addPort,fetchPorts  } from "../features/ports/portSlice";
import { toast } from "react-toastify";

function PortForm() {

    const dispatch = useDispatch();

    const [name, setName] = useState("");
	const [details, setDetails] = useState("");
    const [opening_balance, setOpeningBalance] = useState("");

    const clearForm = () => {
        setName("");
        setOpeningBalance("");
        setDetails("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
		const portData = {
    name,
    opening_balance
};

        try {
			

			//await dispatch( (bankData)).unwrap();
            await dispatch(addPort(portData)).unwrap();
			
			// Refresh bank list
        await dispatch(fetchPorts()).unwrap();

            toast.success("Port added successfully.");

            clearForm();

        } catch (error) {

            toast.error(error || "Unable to add Port.");

        }

    };

    return (

        <div className="card shadow border-0">

            <div className="card-header bg-primary text-white">

                <h5 className="mb-0">

                    <i className="bi bi-person-plus-fill me-2"></i>

                    Add Port

                </h5>

            </div>

            <div className="card-body">

                <form
                    onSubmit={handleSubmit}
                >

                    <div className="mb-3">

                        <label className="form-label">

                            Short Name

                        </label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Port Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />

                    </div>

                    <div className="mb-3">

                        <label className="form-label">

                            Opening Balance

                        </label>

                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Opening Balance"
                            value={opening_balance}
                            onChange={(e) => setOpeningBalance(e.target.value)}
                            required
                        />

                    </div>

                    
				<div className="mb-3">

    <label className="form-label">
        Details
    </label>

    <textarea
        className="form-control"
        placeholder="Enter details about opening balance"
        value={details}
        onChange={(e) => setDetails(e.target.value)}
        rows="4"
    ></textarea>

</div>
                    

                    <button
                        type="submit"
                        className="btn btn-primary w-100"
                    >

                        <i className="bi bi-save me-2"></i>

                        Save Port

                    </button>

                </form>

            </div>

        </div>

    );

}

export default PortForm;